// extracted by mini-css-extract-plugin
module.exports = {"gridcontainer":"MePage_gridcontainer__2IY_e","cover":"MePage_cover__1-VIS","animation":"MePage_animation__24nB0","soundOn":"MePage_soundOn__2uq3H","text":"MePage_text__Aa1Rs"};